import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { InitiatePaymentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { InitiatePaymentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const initiatePayment = (request: InitiatePaymentRequest, options?: CashRequestOptions) =>
  post<InitiatePaymentRequest, InitiatePaymentResponse>('/2.0/cash/initiate-payment', request, {
    ...options,
    rejectOnError: true,
  })
